/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Condition_OperatorInputs */

const cs_automation_condition_operator = /** @type {(inputs: Automation_Condition_OperatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operátor`)
};

const en_automation_condition_operator = /** @type {(inputs: Automation_Condition_OperatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operator`)
};

/**
* | output |
* | --- |
* | "Operator" |
*
* @param {Automation_Condition_OperatorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_condition_operator = /** @type {((inputs?: Automation_Condition_OperatorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Condition_OperatorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_condition_operator(inputs)
	return cs_automation_condition_operator(inputs)
});